import { useFeatureValue } from '@growthbook/growthbook-react'
import useSlugs from '../useSlugs'

export const useSportsbookSlugs = (slug) => {
  const sportsbookProvider = useFeatureValue('igp_sportsbook_provider')
  const [sportsSlug] = useSlugs(['sports'])

  if (sportsbookProvider === 'kambi') {
    if (slug === 'my-bets') return `/${sportsSlug}/bethistory/`

    if (slug === 'bonus') return `/${sportsSlug}/bethistory/active/rewards`
  }

  return `/${slug}/`
}
